import { createApp } from 'vue'
import AssessmentApp from './AssessmentApp.vue'

const assessmentElement = document.querySelector('.Assessment-vue')

createApp(AssessmentApp, {
  uuid: assessmentElement.getAttribute('data-uuid'),
}).mount(assessmentElement)
